export enum LoginErrorsTypes {
  UNAUTHORIZED = 'unauthorized',
  UNAUTHENTICATED = 'unauthenticated'
}

export enum LoginErrorsSubtypes {
  EMAIL_NOT_CONFIRMED = 270,
  TC_NOT_ACCEPTED = 203
}